import Button from '@/components/Button';

export default function NotFound({ t, router }){

    return (
        <>
        <div className='text-center mt-4 font-bold'>
            {t('error.pagenotfound')}
        </div>
        <div className="text-center mt-4">
            <Button                     
                onClick={() => router?.navigate('/')}
                text={t('error.back')}
                type='back'
            />
        </div>
        </>
    );
}
